import { Episode } from '@lyrahealth-inc/shared-app-logic/src/models/episodes/Episodes'
import { ProgramNames } from '@lyrahealth-inc/shared-app-logic/src/models/programs/Programs'

import { canManageAssignmentsForEpisode } from './assignmentAccess'

type AssignmentProviderPayload = {
  provider_id: string
  assigned_by_lyra_id?: string
}

export const getAssignmentProviderPayload = (
  episode: Pick<Episode, 'participants' | 'program_name' | 'provider_id'> | undefined,
  actingProviderLyraId: string,
): AssignmentProviderPayload | undefined => {
  if (!canManageAssignmentsForEpisode(episode, actingProviderLyraId)) {
    return undefined
  }

  if (
    episode?.program_name === ProgramNames.DialecticalBehaviorTherapyTeens &&
    actingProviderLyraId &&
    episode.provider_id !== actingProviderLyraId
  ) {
    return {
      provider_id: episode.provider_id,
      assigned_by_lyra_id: actingProviderLyraId,
    }
  }

  return { provider_id: actingProviderLyraId }
}
